import { apiFetch } from "./client";

export type PublicSeoSerpTemplate = {
  title: string;
  description: string;
  canonicalPath?: string;
  breadcrumbTrail?: string;
};

export type PublicSeoSerpSettings = {
  templates: Record<string, PublicSeoSerpTemplate>;
};

export async function fetchPublicSeoSerpSettings() {
  return apiFetch<{ settings: PublicSeoSerpSettings }>("/api/seo/serp");
}
